<div *ngIf="availableAttrs">
  <div class="row">
    <div class="col-xl-4">
      <ng-select
        #ngSelect
        [items]="availableAttrs"
        [(ngModel)]="selectedAttr"
        (close)="ngSelect.blur()"
        (change)="previewAttr()"
        [disabled]="loading || creating"
        [clearable]="false"
        notFoundText="No fields found"
        placeholder="Choose or type a field name"
      ></ng-select>
    </div>
    <div class="col-xl-8">
      <span [hidden]="!loading && !creating">
        <ab-spinner-inline></ab-spinner-inline
      ></span>
      <button
        class="btn attr-preview__btn"
        (click)="previewAttr(attr?.lastNoticeId)"
        *ngIf="attr?.lastNoticeId && attrNoticeCount !== group.noticeCount"
        [disabled]="loading"
        type="button"
      >
        Process more data
      </button>
      <button
        class="btn attr-preview__btn"
        *ngIf="attr?.lastNoticeId && !attr.created"
        (click)="createGroupAttr()"
        [disabled]="loading || creating || groupAttrsLeft === 0"
        type="button"
      >
        Pin aggregation for this error
      </button>
      <button
        class="btn attr-preview__btn"
        *ngIf="attr?.lastNoticeId && !attr.created"
        (click)="createProjectAttr()"
        [disabled]="loading || creating || projectAttrsLeft === 0"
        type="button"
      >
        Pin aggregation for all errors & project search</button
      ><span
        class="attr-preview__tip"
        *ngIf="projectAttrsLeft === 0 || groupAttrsLeft === 0"
        >Unpin some aggregations to pin more.</span
      >
    </div>
  </div>
  <div
    class="row pt-3"
    *ngIf="attr?.lastNoticeId && attrNoticeCount < group.noticeCount"
  >
    <div class="col-xl-12">
      <div class="progress-wrap">
        <ngb-progressbar
          class="progress"
          type="success"
          [max]="group.noticeCount"
          [value]="attrNoticeCount"
        ></ngb-progressbar>
        <div>
          Processed {{ attrNoticeCount }} out of
          {{ group.noticeCount }} occurrences
        </div>
      </div>
    </div>
  </div>
  <div class="row pt-3">
    <div class="col-md-12">
      <table class="ab-table" *ngIf="attr?.attributes.length > 0">
        <thead>
          <th class="ab-table__header">Value</th>
          <th class="ab-table__header">Count</th>
          <th class="ab-table__header">First seen at</th>
          <th class="ab-table__header">Last seen at</th>
        </thead>
        <tbody>
          <tr
            class="ab-table__row"
            *ngFor="let item of attr?.attributes; trackBy: trackByIndex"
          >
            <td class="ab-table__cell">{{ item.value }}</td>
            <td class="ab-table__cell">{{ item.noticeCount }}</td>
            <td class="ab-table__cell">
              {{ item.firstSeenAt | date: "MMM dd, y HH:mm:ss Z" }}
            </td>
            <td class="ab-table__cell">
              {{ item.lastSeenAt | date: "MMM dd, y HH:mm:ss Z" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
